import buttonRadar from '../shared/button-radar.vue'
import back from '../shared/back.vue'

export default  {

    name: 'discover',

    components: {

        buttonRadar,
        back

    },

    mounted(){

        localStorage.setItem('play', true);

        let app = document.getElementById("app");

        setTimeout(function () {

            app.style.backgroundImage = "";

        }, 200)

    },

}




// WEBPACK FOOTER //
// ./src/components/discover/discover.component.js